import { render, staticRenderFns } from "./MyTicketsAdmin.vue?vue&type=template&id=33ba94ea&"
import script from "./MyTicketsAdmin.vue?vue&type=script&lang=js&"
export * from "./MyTicketsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports